import React, { Component } from 'react'
import UIkit from 'uikit'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import moment from '../../utils/helpers/moment'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import { Redirect } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import BeneficiaireBox from '../../components/BeneficiaireBox'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchSouscripteurAction } from '../../actions/Souscription/Souscripteur'
import { fetchBeneficiairesAction, fetchAddBeneficiaireAction, fetchUpdateBeneficiaireAction, fetchRemoveBeneficiaireAction } from '../../actions/Souscription/Beneficiaire'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Beneficiaire extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
    submitAllBeneficiairesSuccess: false,
    submitAllSuccess: true,
    applyRedirectPrev: false,
    applyRedirectNext: false,
    submitBeneficiaireCount: 0,
    allBeneficiaires: [],
    isAllBeneficiaires: false,
    hasSouscripteurAdded: false,
    notificationAddBeneficiaireError: false,
    notificationUpdateBeneficiaireError: false,
    notificationRemoveBeneficiaireError: false,
    notificationGetBeneficiairesError: false,
    forms: []
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Beneficiaire`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, getReauthenticateCourtiers, reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur, userGetBeneficiaires } = this.props
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        getReauthenticateCourtiers()
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0 || !reauthenticateMembers.userData.souscripteurID) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
      }
    }

    if (this.props.location.state && this.props.location.state.fromDevis) {
      this.handleAddBeneficiaire(null)
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur, userGetBeneficiaires, getBeneficiaires, addBeneficiaire, updateBeneficiaire } = nextProps
    const { allBeneficiaires, submitBeneficiaireCount } = nextState

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
    if (getBeneficiaires.beneficiairesData.length !== this.props.getBeneficiaires.beneficiairesData.length) {
      if (getBeneficiaires.beneficiairesData.data && getBeneficiaires.beneficiairesData.data !== undefined) {
        this.setState((prevState, props) => {
          let allBeneficiaires = [ ...getBeneficiaires.beneficiairesData.data, ...prevState.allBeneficiaires  ]
          if (props.location.state && props.location.state.fromDevisTable) {
            allBeneficiaires[props.location.state.position].beneficiareOpen = true
          }
          return { isAllBeneficiaires: true, allBeneficiaires }
        })
        for (var i = 0; i < allBeneficiaires.length; i++) {

          if (typeof allBeneficiaires[i].lien === "undefined") {
            this.setState({ hasSouscripteurAdded: true })
          }
        }
      }
    }
    if (allBeneficiaires.length !== this.state.allBeneficiaires.length) {
      for (var j = 0; j < allBeneficiaires.length; j++) {
        if (typeof allBeneficiaires[j].lien === "undefined") {
          this.setState({ hasSouscripteurAdded: true })
        }
      }
      this.setState({ allBeneficiaires: [ ...allBeneficiaires ] })
    }
    if ((addBeneficiaire.isSuccess || updateBeneficiaire.isSuccess) && nextState.submitAllSuccess) {

      if (submitBeneficiaireCount === 0 || submitBeneficiaireCount !== this.state.submitBeneficiaireCount) {
        let thisTotalBeneficiaires = allBeneficiaires.length
        if (thisTotalBeneficiaires > submitBeneficiaireCount) {
          this.setState({ submitBeneficiaireCount: submitBeneficiaireCount + 1 })
        }
        if ( thisTotalBeneficiaires === submitBeneficiaireCount) {
          this.setState({ submitAllBeneficiairesSuccess: thisTotalBeneficiaires === submitBeneficiaireCount, submitAllSuccess: false })
        }
      }
    }
    if (nextProps.addBeneficiaire.isError !== this.props.addBeneficiaire.isError) {
      this.setState({ notificationAddBeneficiaireError: nextProps.addBeneficiaire.isError })
    }
    if (nextProps.updateBeneficiaire.isError !== this.props.updateBeneficiaire.isError) {
      this.setState({ notificationUpdateBeneficiaireError: nextProps.updateBeneficiaire.isError })
    }
    if (nextProps.removeBeneficiaire.isError !== this.props.removeBeneficiaire.isError) {
      this.setState({ notificationRemoveBeneficiaireError: nextProps.removeBeneficiaire.isError })
    }
    if (nextProps.getBeneficiaires.isError !== this.props.getBeneficiaires.isError) {
      this.setState({ notificationGetBeneficiairesError: nextProps.getBeneficiaires.isError })
    }
  }

  handleBeneficiairePrev = event => {
    event.preventDefault()
    const { allBeneficiaires, isCurrentLoginCourtier } = this.state
    const { userAddBeneficiaire, userUpdateBeneficiaire, reauthenticateMembers, reauthenticateCourtiers } = this.props

    if (allBeneficiaires.length) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        if (allBeneficiaires[i]._id) {
          userUpdateBeneficiaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allBeneficiaires[i]))
        }else {
          if(isCurrentLoginCourtier) {
            userAddBeneficiaire(reauthenticateCourtiers.courtierData.souscripteurID, serializeJavascript.sanitize(allBeneficiaires[i]))
          }else {
            userAddBeneficiaire(reauthenticateMembers.userData.souscripteurID, serializeJavascript.sanitize(allBeneficiaires[i]))
          }
        }
      }
      this.setState({ applyRedirectPrev: true })
    } else {
      this.setState({ applyRedirectPrev: true, submitAllBeneficiairesSuccess: true })
    }
  }

  handleBeneficiaireNext = event => {
    event.preventDefault()
    const { allBeneficiaires, isCurrentLoginCourtier } = this.state
    const { userAddBeneficiaire, userUpdateBeneficiaire, reauthenticateMembers, reauthenticateCourtiers } = this.props

    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        if (allBeneficiaires[i]._id) {
          userUpdateBeneficiaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allBeneficiaires[i]))
        }else {
          if(isCurrentLoginCourtier) {
            userAddBeneficiaire(reauthenticateCourtiers.courtierData.souscripteurID, serializeJavascript.sanitize(allBeneficiaires[i]))
          }else {
            userAddBeneficiaire(reauthenticateMembers.userData.souscripteurID, serializeJavascript.sanitize(allBeneficiaires[i]))
          }
          /*
          if (!!(allBeneficiaires[i].isSouscripteurNoAdd || allBeneficiaires[i].isSouscripteurYesAdd)) {
            userAddBeneficiaire(reauthenticateMembers.userData.souscripteurID, allBeneficiaires[i])
          }*/
        }
      }
      this.setState({ applyRedirectNext: true })
    }
  }

  handleAddBeneficiaire = event => {
    if (event) {
      event.preventDefault()
    }
    const { allBeneficiaires } = this.state

    const newBeneficiaire = {
      lien: "",
      firstname: "",
      lastname: "",
      birthday: "",
      nationality: "",
      sex: "",
      taille: "",
      poids: "",
      profession: "",
      formule : "",
      beneficiareOpen: true,
    }
    for (var i = 0; i < allBeneficiaires.length; i++) {
      if (allBeneficiaires[i].beneficiareOpen) {
        allBeneficiaires[i]["beneficiareOpen"] = false // permet de fermer item
      }
    }
    this.setState((prevState) => {
      return { allBeneficiaires: [ ...prevState.allBeneficiaires, newBeneficiaire ] }
    })
    //this.savePreviewsBeneficiaire()
  }

  handleRemoveBeneficiaire = (beneficiaireID, beneficiairePosition) => {
    const { allBeneficiaires } = this.state
    const { userRemoveBeneficiaire } = this.props

    let thisLocalAllBeneficiaires = allBeneficiaires.filter((_, index) => {
      return index !== beneficiairePosition
    })
    if (thisLocalAllBeneficiaires.length !== null) {
      for (var i = 0; i < thisLocalAllBeneficiaires.length; i++) {
        if (thisLocalAllBeneficiaires[i].beneficiareOpen) {
          thisLocalAllBeneficiaires[i]["beneficiareOpen"] = false // permet de fermer item
        }
      }
    }else {
      this.setState({ hasSouscripteurAdded: false })
    }
    if (typeof allBeneficiaires[beneficiairePosition].lien === "undefined") {
      this.setState({ hasSouscripteurAdded: false })
    }
    if (beneficiaireID !== null) {
      userRemoveBeneficiaire(beneficiaireID)
    }
    this.setState((prev, props) => {
      prev.forms.splice(beneficiairePosition, 1)
      return {forms: prev.forms, allBeneficiaires: thisLocalAllBeneficiaires}
    })
  }

  handleYesAddSouscripteur = beneficiairePosition => {
    const { allBeneficiaires } = this.state
    const { getSouscripteur } = this.props

    const newBeneficiaire = {
      firstname: getSouscripteur.souscripteurData.firstname,
      lastname: getSouscripteur.souscripteurData.lastname,
      birthday: moment(getSouscripteur.souscripteurData.birthday),
      nationality: getSouscripteur.souscripteurData.nationality,
      sex: "",
      taille: "",
      poids: "",
      profession: "",
      formule : "",
      beneficiareOpen: true,
      isSouscripteurYesAdd: true,
    }
    allBeneficiaires[beneficiairePosition] = newBeneficiaire
    this.setState({ allBeneficiaires, hasSouscripteurAdded: true })
  }

  handleNoAddSouscripteur = beneficiairePosition => {
    const { allBeneficiaires } = this.state
    const newBeneficiaire = {
      lien: "",
      firstname: "",
      lastname: "",
      birthday: "",
      nationality: "",
      sex: "",
      taille: "",
      poids: "",
      profession: "",
      formule : "",
      beneficiareOpen: true,
      isSouscripteurNoAdd: true,
    }
    allBeneficiaires[beneficiairePosition] = newBeneficiaire
    this.setState({ allBeneficiaires })
  }

  handleChangeBeneficiaire = (value, name, position) => {
    const { allBeneficiaires } = this.state

    allBeneficiaires[position][name] = value
    this.setState({ allBeneficiaires })
  }

  applyGetBeneficiaires() {
    const { getBeneficiaires } = this.props
    this.setState({allBeneficiaires: [ ...getBeneficiaires.beneficiairesData.data ] })
  }

  checkFormValid = (position, isValid) => {
    this.setState((prev) => {
      prev.forms[position] = isValid
      return {forms: prev.forms}
    })
  }
  NotificationAddBeneficiaireError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur ajout bénéficiaire",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationAddBeneficiaireError: false })
  }
  NotificationUpdateBeneficiaireError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur mise à jour bénéficiaire",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationUpdateBeneficiaireError: false })
  }
  NotificationRemoveBeneficiaireError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur suppression bénéficiaire",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationRemoveBeneficiaireError: false })
  }
  NotificationGetBeneficiairesError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur récuperation des bénéficiaires",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationGetBeneficiairesError: false })
  }

  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur, getBeneficiaires, addBeneficiaire, updateBeneficiaire, removeBeneficiaire } = this.props
    const { isAllBeneficiaires, allBeneficiaires, submitAllBeneficiairesSuccess, applyRedirectPrev, applyRedirectNext,
      notificationAddBeneficiaireError,
      notificationUpdateBeneficiaireError,
      notificationRemoveBeneficiaireError,
      notificationGetBeneficiairesError,
      isCurrentLoginCourtier,
      hasSouscripteurAdded,
    } = this.state
    let invalidFormPrev = this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b)
    let invalidFormNext = allBeneficiaires.length === 0 ||(this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b))

    if (isAllBeneficiaires && !allBeneficiaires) {
      this.applyGetBeneficiaires()
    }

    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending") && <Redirect to="/soumis" push/>}
          {getSouscripteur.souscripteurData.status === "police-active" && <Redirect to="/validation-souscription" push/>}
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-menu-tab-content">
                  <SouscriptionSwitcher match={match} />
                    {(getSouscripteur.isLoading || getBeneficiaires.isLoading || addBeneficiaire.isLoading || updateBeneficiaire.isLoading || removeBeneficiaire.isLoading || allBeneficiaires === undefined)
                      ?
                        <div className="aps-spinner-component-loading">
                          <div className="uk-spinner">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                               <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                            </svg>
                          </div>
                          <div className="aps-section-register-desc">chargement en cours</div>
                        </div>
                      :
                        <div>
                          <div className="uk-text-center aps-dashboard-beneficiare-title uk-text-bold">
                            Complétez les informations concernant le(s) bénéficiaire(s)
                          </div>
                          {addBeneficiaire.isError && notificationAddBeneficiaireError &&
                            <div>
                              { this.NotificationAddBeneficiaireError() }
                            </div>
                          }
                          {updateBeneficiaire.isError && notificationUpdateBeneficiaireError &&
                            <div>
                              { this.NotificationUpdateBeneficiaireError() }
                            </div>
                          }
                          {removeBeneficiaire.isError && notificationRemoveBeneficiaireError &&
                            <div>
                              { this.NotificationRemoveBeneficiaireError() }
                            </div>
                          }
                          {getBeneficiaires.isError && notificationGetBeneficiairesError &&
                            <div>
                              { this.NotificationGetBeneficiairesError() }
                            </div>
                          }
                          {(submitAllBeneficiairesSuccess && applyRedirectNext) &&
                            <div>
                              <Redirect to="/devis" push/>
                            </div>
                          }
                          {(submitAllBeneficiairesSuccess && applyRedirectPrev) &&
                            <div>
                              <Redirect to="/souscripteur" push/>
                            </div>
                          }
                          {(getBeneficiaires.isSuccess && isAllBeneficiaires) &&
                            <div>
                              <div className="aps-dashboard-beneficiare-container">
                                <ul className="aps-dashboard-beneficiare-accordion-container" data-uk-accordion>

                                  {
                                    allBeneficiaires.map((beneficiare, index) => (
                                      <BeneficiaireBox
                                        key={index}
                                        beneficiairePosition={index + 1}
                                        hasSouscripteurAdded={getSouscripteur.souscripteurData.isEntreprise ? getSouscripteur.souscripteurData.isEntreprise : hasSouscripteurAdded}
                                        isEntreprise={getSouscripteur.souscripteurData.isEntreprise}
                                        beneficiaireData={beneficiare}
                                        removeBeneficiaire={this.handleRemoveBeneficiaire}
                                        checkYesAddSouscripteur={this.handleYesAddSouscripteur}
                                        checkNoAddSouscripteur={this.handleNoAddSouscripteur}
                                        checkChangeBeneficiaire={this.handleChangeBeneficiaire}
                                        checkFormValid={this.checkFormValid}
                                      />
                                    ))
                                  }

                                </ul>

                                <div className="uk-text-center aps-dashboard-beneficiare-action-btn-mobile">
                                  <button
                                    className="uk-button aps-btn-add-beneficiaire aps-btn-add-beneficiaire-this-dashboard"
                                    onClick={(event) => this.handleAddBeneficiaire(event)}
                                  >
                                    <span
                                      className="aps-icon-add-beneficiaire"
                                      data-uk-icon="icon: plus-circle"
                                    />
                                    Ajouter un bénéficiaire
                                  </button>
                                </div>
                              </div>
                            </div>
                          }

                          <div className="aps-dashboard-souscription-switch">
                            <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-second">
                              <button
                                className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn  ${invalidFormPrev ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                onClick={(event) => this.handleBeneficiairePrev(event)}
                                disabled={this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b)}
                              >Section précédente</button>

                              <button
                                className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${invalidFormNext ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                onClick={(event) => this.handleBeneficiaireNext(event)}
                                disabled={allBeneficiaires.length === 0 ||(this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b))}
                              >Section suivante</button>
                            </div>
                          </div>

                        </div>
                    }
                  </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
            </Dashboard>
          }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getSouscripteur, getBeneficiaires, addBeneficiaire, updateBeneficiaire, removeBeneficiaire }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getSouscripteur,
    getBeneficiaires,
    addBeneficiaire,
    updateBeneficiaire,
    removeBeneficiaire,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userGetBeneficiaires: (souscripteurID) => dispatch(fetchBeneficiairesAction(souscripteurID)),
    userAddBeneficiaire: (souscripteurID, beneficiaireData) => dispatch(fetchAddBeneficiaireAction(souscripteurID, beneficiaireData)),
    userUpdateBeneficiaire: (beneficiaireID, beneficiaireData) => dispatch(fetchUpdateBeneficiaireAction(beneficiaireID, beneficiaireData)),
    userRemoveBeneficiaire: (beneficiaireID) => dispatch(fetchRemoveBeneficiaireAction(beneficiaireID)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Beneficiaire)



// WEBPACK FOOTER //
// ./src/containers/Beneficiaire/index.js